"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const VerticalList_1 = __importDefault(require("./VerticalList/VerticalList"));
exports.default = VerticalList_1.default;
//# sourceMappingURL=index.js.map